export enum GregorioSign {
  NO_SIGN = 0x00,
  PUNCTUM_MORA = 0x01, 
  AUCTUM_DUPLEX = 0x02, 
  V_EPISEMA = 0x10, 
  V_EPISEMA_PUNCTUM_MORA = 0x11,
  V_EPISEMA_AUCTUM_DUPLEX = 0x12, 
  /* more rare signs, for now they can't be used with the others */
  ACCENTUS = 0x03,
  ACCENTUS_REVERSUS = 0x04,
  CIRCULUS = 0x05,
  SEMI_CIRCULUS = 0x06,
  SEMI_CIRCULUS_REVERSUS = 0x07,
  /* signs of a bar */
  BAR_H_EPISEMA = 0x08,
  V_EPISEMA_BAR_H_EPISEMA = 0x18,
  /* musica ficta */
  MUSICA_FICTA_FLAT = 0x09,
  MUSICA_FICTA_NATURAL = 0x0a,
  MUSICA_FICTA_SHARP = 0x0b,
}
